import BaseApi from './BaseApi';

export type StaffId = {
  accountId: string;
  bucketName: string;
};

/**
 * アカウントの有効状態設定API。
 */
class DeleteStaffApi extends BaseApi {
  async delete(params: StaffId) {
    return await this.execute('deleteStaffApi', {
      method: 'POST',
      body: params
    }).then(({ status }) => status === 1);
  }
}

export default DeleteStaffApi;
